export default class ForecastedDepreciation {
  /**
   *
   * @param {Number} forecastedRevenue
   * @param {Number} depreciationPercentageRevenue
   * @param {Number} growthRate
   */
  constructor({
    forecastedRevenue = 0,
    depreciationPercentageRevenue = 0,
    growthRate = 0,
    analystNote = ""
  }) {
    this.forecastedRevenue = forecastedRevenue
    this.depreciationPercentageRevenue = depreciationPercentageRevenue
    this.growthRate = growthRate
    this.analystNote = analystNote
  }

  get depreciationAmount() {
    return this.forecastedRevenue * (this.depreciationPercentageRevenue / 100)
  }

  get forecastedValue() {
    return this.depreciationAmount * this.growthRate
  }
}